import axios from 'axios';

// Create an axios instance
const api = axios.create({
  baseURL: 'https://api.label.whats-viral.me', // your FastAPI base URL
});

// Optional: attach token automatically from localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
